import React from 'react'
import {
    Create,
    SimpleForm,
    TextInput,
    NumberInput,
} from 'react-admin'


export const SistemaInterconectadoCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <NumberInput source="id" />
            <TextInput source="name" />
            <TextInput source="code" />
        </SimpleForm>
    </Create>
);
